import { render, staticRenderFns } from "./TierEnrollTableData.vue?vue&type=template&id=081ce87c&"
import script from "./TierEnrollTableData.vue?vue&type=script&lang=js&"
export * from "./TierEnrollTableData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports